export default __webpack_public_path__ + "static/media/warning.f8e775cf.svg";